module.exports = __webpack_public_path__ + "img/banner.185a4d61.png";